import { Directive, forwardRef } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';

function validateSmallInt() {
	return (c: UntypedFormControl) => {
		const SMALLINT_REGEXP = /^((\d{1,4}|[012]\d{4}|3[01]\d{3}|32[0123456]\d{2}|327[012345]\d{1}|3276[01234567]))$|null$/i;

		return SMALLINT_REGEXP.test(c.value) ? null : {
			int32: {
				valid: false
			}
		};
	};
}

@Directive({
	selector: '[appSmallIntValidator]',
	providers: [
		{provide: NG_VALIDATORS, useExisting: forwardRef(() => SmallIntValidatorDirective), multi: true}
	]
})
export class SmallIntValidatorDirective implements Validator {
	validator: Function;

	constructor() {
		this.validator = validateSmallInt();
	}

	validate(c: UntypedFormControl) {
		return this.validator(c);
	}

}
